import { render, staticRenderFns } from "./EscapeDetail.vue?vue&type=template&id=3f213109&scoped=true"
import script from "./EscapeDetail.vue?vue&type=script&lang=js"
export * from "./EscapeDetail.vue?vue&type=script&lang=js"
import style0 from "./EscapeDetail.vue?vue&type=style&index=0&id=3f213109&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f213109",
  null
  
)

export default component.exports